<template>
  <div>
    <vxe-modal
      v-model="djEditVisible"
      :before-hide-method="btnCancel"
      width="50%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>{{ djTitle }}</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <!-- <el-button type="primary" @click="saveEdit">确 定</el-button> -->
              <el-button type="primary" v-show="isExcel" @click="getExcel"
                >导出</el-button
              >
              <el-button @click="btnCancel">关闭</el-button>
            </div>
          </el-row>
        </div>
        <div class="tableform">
          <vxe-table
            :data="tableData"
            border
            @row-click="clickRow"
            style="width: 100%"
            height="388"
            class="mytable-scrollbar"
          >
            <vxe-table-column
              v-for="(item, key) in tablekey"
              :key="key"
              :field="item.value"
              :title="item.name"
              :width="item.hasOwnProperty('width') ? item.width : '200'"
              align="center"
              :show-overflow-tooltip="
                item.hasOwnProperty('tooltip') ? item.tooltip : true
              "
            >
            </vxe-table-column>
          </vxe-table>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    djTitle: {
      required: true,
    },
    djEditVisible: {
      required: true,
    },
    tableData: {
      required: true,
    },
    tablekey: {
      required: true,
    },
    isExcel: {
      required: true,
    },
    Width: {
      default: "680px",
    },
  },
  created() {},
  methods: {
    btnCancel() {
      this.$emit("update:djEditVisible", false);
    },
    saveEdit() {
      this.$emit("update:djEditVisible", false);
    },
    getExcel() {
      this.getreportExcel();
      this.$emit("update:djEditVisible", false);
    },
    clickRow(row) {
      this.$emit("getRow", row);
      // console.log(row);
    },
    getreportExcel() {
      if (this.tableData.length < 1) {
        this.$message.error("没有数据可以统计！");
        return;
      }
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel");
        const tHeader = [];
        const filterVal = [];
        this.tablekey.forEach((item) => {
          tHeader.push(item.name);
          filterVal.push(item.value);
        });
        const list = this.tableData;
        const data = this.formatJson(filterVal, list);
        const fileName = this.djTitle;
        export_json_to_excel(tHeader, data, fileName);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
  mounted() {},
  components: {},
  watch: {},
};
</script>
<style lang="scss"  scoped>
.option {
  margin: 0px 0 20px 20px;
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
</style>
<style scoped>
.vxe-table__row {
  cursor: pointer;
}
.vxe-table td:first-child {
  width: 80px;
}
.tableform /deep/ .vxe-table__header,
.tableform /deep/ .vxe-table__body-wrapper .vxe-table__body,
.tableform /deep/ .vxe-table__body-wrapper .vxe-table__body td > div {
  width: 100% !important;
}
/*滚动条整体部分*/
.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*滚动条的轨道*/
.mytable-scrollbar ::-webkit-scrollbar-track {
  background-color: #ffffff;
}

/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #f1f1f1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}

/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
  background-color: #ffffff;
}
.single-content-wrapper {
  background-color: #fff;
  padding-bottom: 15px;
}

.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}
</style>

